module.exports = __webpack_public_path__ + "img/finger/finger@3x.png";


//////////////////
// WEBPACK FOOTER
// ./img/finger/finger@3x.png
// module id = 66
// module chunks = 3